import { CheckboxInput } from './CheckboxInput'
import { withCheckboxInput } from './withCheckboxInput'

const ConnectedCheckbox = withCheckboxInput(CheckboxInput)

export { ConnectedCheckbox as CheckboxInput }
